/**
 * React Query client instance.
 * Exported so it can be used to clear cache on logout/login.
 */

import { QueryClient } from '@tanstack/react-query'
import { logError } from '@utils/logger'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 401 errors (authentication failures)
        if (error?.response?.status === 401) {
          return false
        }
        // Retry once for other errors
        return failureCount < 1
      },
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      onError: (error: any) => {
        // Don't log 401 errors - they're expected when user is logged out
        if (error?.response?.status !== 401) {
          logError('[React Query] Query error:', error)
        }
      },
    },
  },
})

